import request from '@/utils/request'

export function getJsonById(params) {
  return request({
    url: '/pages/getJsonById',
    method: 'get',
    params:params
  })
}
export function getIndex() {
  return request({
    url: '/pages/getIndex',
    method: 'get'
  })
}export function getPageById(params) {
  return request({
    url: '/pages/getPageById',
    method: 'get',

    params: params
  })
}
export function getSetting(params) {
  return request({
    url: 'admin/getSetting',
    method: 'get',
    params: params
  })
}
export function gethf(params) {
  return request({
    url: '/hf/gethf',
    method: 'get',
    params:params
  })
}export function savehf(params) {
  return request({
    url: '/hf/savehf',
    method: 'post',

    data:params
  })
}export function getGonggaoList(params) {
  return request({
    url: '/gonggao/getGonggaoListS',
    method: 'get',

    params:params
  })
}export function getIndexInfo(params) {
  return request({
    url: '/pages/getIndexInfo',
    method: 'get',

    params:params
  })
}export function saveZixun(params) {
  return request({
    url: '/zixun/saveZixun',
    method: 'post',
    data:params
  })
}

export function doSendCodeByPhone(params) {
  return request({
    url: '/zixun/doSendCodeByPhone',
    method: 'post',
    data:params
  })
}export function getLKUrlAndGetPhoneKey(params) {
  return request({
    url: '/zixun/getLKUrlAndGetPhoneKey',
    method: 'post',
    data:params
  })
}
export function sendMsM(params) {
  return request({
    url: '/zixun/sendMsM',
    method: 'post',
    data:params
  })
}

export function checkMsM(params) {
  return request({
    url: '/zixun/checkMsM',
    method: 'post',
    data:params
  })
}
export function getLKUrl(params) {
  return request({
    url: '/zixun/getLKUrl',
    method: 'post',
    data:params
  })
}
export function setUsed(params) {
  return request({
    url: '/zixun/setUsed',
    method: 'post',
    data:params
  })
}